import React, { useEffect, useState } from "react";
import { TitleSetup } from "../Datas/Functions/titleSetup";
import ItemSection from "../Components/ItemSection/ItemSection";
import { useSiteData } from "../Contexts/SiteContext";
import SearchItemSection from "../Components/SearchItemSection/SearchItemSection";

const Products = (meta) => {
  const { products } = useSiteData();
  const [showProducts, setShowProducts] = useState([]);
  useEffect(() => {
    setShowProducts(products);
  }, [products]);
  TitleSetup({...meta});
  return (
    <>
      <SearchItemSection />
      {products?.length > 0 && (
        <ItemSection
          heading={"ALl Products"}
          prods={products}
          showAll={true}
          showCount={-1}
        />
      )}
    </>
  );
};

export default Products;
